import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';
import React, { useState, useEffect } from 'react';
import LargePopup from 'components/popup/large-popup';
import congratsTick from 'images/LAMF_thank_you_tick.svg';

const ThankYouContainer = styled.div<CommonStyledComponentProps>`

    .icon{
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '100px' : '120px'};
        height: ${(props: CommonStyledComponentProps) => props.isMobile ? '100px' : '120px'};
        left: ${(props: CommonStyledComponentProps) => props.isMobile ? '98px' : '325.5px;'}; 
        flex-shrink: 0;
        position: relative;
        margin-bottom: ${(props: CommonStyledComponentProps) => props.isMobile ? '20px' : '10px'};
    }

    .popup{
        display: flex;
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '328px' : '819px'};
        height: ${(props: CommonStyledComponentProps) => props.isMobile ? '324px' : '364px'};
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--spacing-sp-16,16px)' : 'var(--spacing-sp-16, 16px) var(--spacing-sp-24, 24px)'}; 
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--spacing-sp-4,4px)' : '0px'} 
        flex-shrink: 0;
    }

    .head{
        align-self: stretch;
        color: var(--color-secondary-b-450, #0AADE1);
        font-family: var(--app-style-body, Roboto);
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-size-fs-lg, 20px)' : 'var(--app-size-fs-lg, 18px)'}; 
        font-style: normal;
        font-weight: 500;
        text-align: center;
        line-height: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-line-height-lh-md, 24px);' : 'var(--app-line-height-lh-md, 28px);'};  
        letter-spacing: ${(props: CommonStyledComponentProps) => props.isMobile ? '0.026px;' : ''}; 
    } 

    .para{
        align-self: stretch;
        color: var(--color-netural-600, #191C1B);
        font-family: var(--app-style-micro, Roboto);
        font-size: var(--app-size-fs-md, 14px);
        font-style: normal;
        text-align: center;
        font-weight: 400;
        line-height: var(--app-line-height-lh-sm, 20px);
        letter-spacing: 0.0024em;
        margin-bottom: ${(props: CommonStyledComponentProps) => props.isMobile ? '20px' : '30px'};
        margin-top: ${(props: CommonStyledComponentProps) => props.isMobile ? '10px' : '20px'};
    }
    
    hr.custom-line {
        width: 296px;
        height: 1px;
        background: var(--color-secondary-b-400, #E9F1FF);
        margin-bottom: 1px;
    }

    .btn-primary:hover {
        opacity: 0.8;
    }

    .btn-primary {
        position: relative;
        gap: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        padding: 10px 10px;
        font-size: 14px;
        cursor: pointer;
        box-sizing: border-box;
        background: var(--color-netural-600, #191C1B);
        border: 1px solid var(--color-netural-600, #191C1B);
        color: white;
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '296px;' : '220px'};
        left : ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '36%'};;
    }
`
interface ThankYouProps {
    onClose: Function;
}

const RedeemPageThankYouPopup: React.FC<ThankYouProps> = ({ onClose }) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [showSuccessPopup, setShowSuccessPopup] = useState<any>({ show: false });
    const onClosePopup = () => {
        setShowSuccessPopup({ show: false });
        onClose();
    }

    return (
        <div>
            <LargePopup
                closable={isMobile || !showSuccessPopup.show}
                modalWidth={'fit-content'}
                onClose={onClosePopup}
                style={{background: 'transparent'}}
                isLAMFRedeemPopup = {true}
            >
                <ThankYouContainer isMobile={isMobile}>
                    <div className="popup">
                        <div>
                            <img className="icon" src={congratsTick} alt="success-icon" />
                        </div>
                        <p className = "head">Thank you for your interest!</p>
                        <hr className="custom-line"/>
                        <p className = "para">Our team will be in touch with you via phone within 24 to 48 hours. Stay tuned!</p>
                        <button className="btn btn-primary" onClick={()=> {onClosePopup(); 
                            document.body.style.overflow = 'scroll';}} >Back to site</button> 
                    </div>
                </ThankYouContainer>
            </LargePopup>
        </div>
    );
}

export default RedeemPageThankYouPopup;